<template>
  <div>
    <b-breadcrumb class="mb-2">
      <b-breadcrumb-item :to="{name:'home'}">
        <p class="d-flex align-items-center">
          <feather-icon
            icon="HomeIcon"
            size="18"
            class="cursor-pointer"
          />
          <span style="margin-left: 0.5rem">Home</span>
        </p>
      </b-breadcrumb-item>

      <b-breadcrumb-item :to="{name:'order-details',params:{id:$route.params.id}}">
        Order #{{ $route.params.id }}
      </b-breadcrumb-item>

      <b-breadcrumb-item active>
        Reception
      </b-breadcrumb-item>
    </b-breadcrumb>

    <b-card
      no-body
    >

      <div class="m-2 d-flex justify-content-between">
        <h1>Reception List</h1>
        <b-button
          id="buttonUpsert"
          variant="primary"
          @click="openModal"
        >
          Deliver product
        </b-button>
      </div>

      <b-table
        ref="refInvoiceListTable"
        responsive
        show-empty
        striped
        :busy="isLoading"
        :items="list"
        :fields="tableColumns"
        primary-key="id"
        empty-text="No matching records found"
        class="position-relative"
      >

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle" />
            <strong class="ml-1">Loading...</strong>
          </div>
        </template>

        <template #head(actions)="data">
          <div class="float-right">
            {{ data.label }}
          </div>
        </template>

        <template #cell(products)="receptionData">
          <b-table
            bordered
            :items="receptionData.item.products"
            :fields="productColumns"
          />
        </template>

        <template #cell(actions)="data">
          <div class="text-nowrap w-100 d-flex justify-content-end">
            <feather-icon
              :id="`invoice-row-${data.item.id}-send-icon`"
              icon="EyeIcon"
              class="cursor-pointer mr-2"
              size="16"
              @click="$router.push({
                name:'order-details',
                params:{
                  id:data.item.id
                }
              })"
            />
          </div>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              Showing {{ paginationMeta.from }} to {{ paginationMeta.to }} of {{ paginationMeta.of }} entries
            </span>
          </b-col>
          <!-- ? Pagination-->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="pagination.page"
              :total-rows="pagination.totalPage * pagination.perPage"
              :per-page="pagination.perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>
        </b-row>
      </div>

      <reception-upsert
        :id="updateId"
        :show="show"
        :method-type="methodType"
        @update:show="modalToggler"
        @update:data="findAll"
      />
    </b-card>
  </div>

</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BCard, BTable, BSpinner, BRow, BCol, BPagination, BButton,
  BBreadcrumb, BBreadcrumbItem,
} from 'bootstrap-vue'
import ReceptionUpsert from '@/views/reception/components/ReceptionUpsert.vue'
// eslint-disable-next-line import/no-cycle
import useReception from '@/composables/useReception'

export default {
  components: {
    BCard,
    BTable,
    BSpinner,
    BRow,
    BCol,
    BPagination,
    BButton,
    ReceptionUpsert,
    BBreadcrumb,
    BBreadcrumbItem,
  },
  setup() {
    const {
      list,
      region,
      tableColumns,
      isLoading,
      pagination,
      paginationMeta,
      findAll,
    } = useReception()
    const show = ref(false)
    const updateId = ref(null)
    const methodType = ref('create')

    const productColumns = [
      {
        key: 'product.name',
        label: 'Name',
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'count',
        label: 'Count',
      },
      {
        key: 'price',
        label: 'Price',
      },
      {
        key: 'total',
        label: 'Total',
      },
      {
        key: 'warehouse.name',
        label: 'Warehouse',
      },
    ]

    function openModal() {
      show.value = true
    }

    function update(id) {
      updateId.value = id
      methodType.value = 'update'
      openModal()
    }

    function remove(id) {
      console.log(id)
    }

    function modalToggler(mShow) {
      if (methodType.value === 'update' && !mShow) {
        updateId.value = null
      }

      show.value = mShow
    }

    findAll()

    return {
      show,
      list,
      region,
      tableColumns,
      methodType,
      updateId,
      isLoading,
      pagination,
      paginationMeta,
      productColumns,

      openModal,
      modalToggler,
      update,
      remove,
      findAll,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
